import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">瓜友热评</h2>
          <p className="text-foreground-500 text-sm md:text-base">千万吃瓜群众在线讨论</p>
        </div>
        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {commentsData.map((comment, i) => (
            <div
              key={comment.id}
              className="p-5 rounded-xl bg-background-100 border border-background-200 animate-fade-in-up"
              style={{ animationDelay: `${i * 120}ms` }}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 font-bold text-sm">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-foreground-700 text-sm leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-4">
                <button className="flex items-center gap-1.5 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer text-xs">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes.toLocaleString()}</span>
                </button>
                <button className="flex items-center gap-1.5 text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer text-xs">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}